import { getCarrierDisplayName } from 'helpers/appointments/appointments';
import { getStateNameFromStateCode } from 'helpers/states';

export function getCarrierAppointmentsSidebarTitle({
  currentTab,
  byStateTabId,
  activeCarrier,
  mapSelectedStateCode
}) {
  if (currentTab === byStateTabId) {
    if (activeCarrier.name) {
      return getCarrierDisplayName(activeCarrier.carrier);
    }
    if (mapSelectedStateCode) {
      return getStateNameFromStateCode(mapSelectedStateCode);
    }
    return '';
  }
  if (activeCarrier.name) {
    return getCarrierDisplayName(activeCarrier.carrier);
  }
  return '';
}
